/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React, { Suspense, useState } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { AuthProps } from "aws-amplify-react/props";
import Logout from "./Logout";
import {
  getUrlParam,
  isProPlan,
  isStandardPlan,
  isSupportRole,
  isTrial,
} from "../Authenticator/utils";
import Support from "../Support";
import { MessageDialogParams } from "../../types/MessageDialogParams";
import ConfirmationDialog from "../ConfirmationDialog";

import MyAccount from "../MyAccount";

const Home: React.FC<AuthProps> = ({ authData }) => {
  const { plan = "", role = "" } = authData.signInUserSession.idToken.payload;
  const zendeskReturnToUrl = getUrlParam("return_to");
  const [invoiceMessage, setInvoiceMessage] =
    useState<MessageDialogParams | null>(null);
  const history = useHistory();

  if (zendeskReturnToUrl) {
    // Redirect back to Zendesk portal if this request was originated from Zendesk,
    // post user authentication.
    return <Support returnTo={zendeskReturnToUrl} plan={plan}></Support>;
  }

  const getMyAccountPaths = () => {
    const myAccountPaths = ["/", "/MyAccount", "/Company"];
    if (role !== "USER") {
      myAccountPaths.push("/Billing");
      if (isStandardPlan(plan) || isProPlan(plan) || isSupportRole(role)) {
        myAccountPaths.push("/Contacts");
      }
      if (isProPlan(plan) || isTrial(plan) || isSupportRole(role)) {
        myAccountPaths.push("/Developer");
      }
    }
    if (isSupportRole(role)) {
      myAccountPaths.push("/Manage");
      myAccountPaths.push("/Manage/:page");
    }
    return myAccountPaths;
  };

  return (
    <React.Fragment>
      <Suspense fallback={<div></div>}>
        <Switch>
          <Route path="/Logout" exact component={Logout} />
          <Route path="/Support" exact render={() => <Support plan={plan} />} />
          {plan === "expired" && (
            <Route exact component={Logout} />
          )}
          <Route
            path={getMyAccountPaths()}
            exact
            render={(props) => <MyAccount {...props} authData={authData} />}
          />
        </Switch>
      </Suspense>
      {invoiceMessage && (
        <ConfirmationDialog
          title={invoiceMessage.title}
          message={invoiceMessage.message}
          onOk={() => {
            setInvoiceMessage(null);
            history.push("/Billing");
          }}
        />
      )}
    </React.Fragment>
  );
};

export default Home;
